import { Component, OnInit, Input, Output } from '@angular/core';
import { EnumService } from '../../../core/services/enum.service';
import { EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-enum',
    templateUrl: './enum.component.html',
    styleUrls: ['./enum.component.css'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => EnumComponent), multi: true }]
})

export class EnumComponent implements OnInit, ControlValueAccessor {
    @Input() type = '';
    @Input('select-all') selectAll = 'true';
    @Input() value = '';
    @Output('change') change: EventEmitter<any> = new EventEmitter<any>();
    @Output('load') load: EventEmitter<any> = new EventEmitter<any>();

    list = [];

    constructor(
        private enumService: EnumService
    ) { }

    ngOnInit() {
        const type = this.type;
        this.enumService.getList(type).then(
            (data) => {
                if (data && data.length) {
                    data.sort((a, b) => {
                        return a.sort - b.sort;
                    });

                    this.list = data;
                } else {
                    console.log('Enum Empty:', data);
                    this.list = [];
                }
                this.load.emit(this.list.length);
            }
        );
    }

    handleChange(event) {
        event.stopPropagation();
        this.change.emit(this.value);
        this.propagateChange(this.value);
    }

    writeValue(value: any): void {

    }

    propagateChange = (_: any) => { };
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {

    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/enum/enum.component.ts